/* eslint-disable no-console */
import { BaseApi } from "./base-api";

const resourceKey = "synonyms/update_synonyms_data";

export const SynonymsApi = {
  update_synonyms_data: (params: any) => BaseApi.create(resourceKey, params),
};
